import { render, staticRenderFns } from "./leaderboards.vue?vue&type=template&id=2c67847d&scoped=true&"
import script from "./leaderboards.vue?vue&type=script&lang=js&"
export * from "./leaderboards.vue?vue&type=script&lang=js&"
import style0 from "./leaderboards.vue?vue&type=style&index=0&id=2c67847d&lang=scss&scoped=true&"
import style1 from "./leaderboards.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c67847d",
  null
  
)

export default component.exports